import React from 'react';
import { Variants } from 'framer-motion';
import * as S from './Grid.styles';

const containerVariants: Variants = {
  hidden: { opacity: 0, y: 20 },
  visible: { 
    opacity: 1, 
    y: 0,
    transition: { duration: 0.5, ease: 'easeOut' }
  },
};

interface GridContainerProps {
  title: string;
  children: React.ReactNode;
}

const GridContainer: React.FC<GridContainerProps> = ({ title, children }) => {
  return (
    <S.GridWrapper
      variants={containerVariants}
      initial="hidden"
      animate="visible"
    >
      <S.GridHeader>
        <S.Title>{title}</S.Title>
      </S.GridHeader>

      <S.DataGridContainer>
        {children}
      </S.DataGridContainer>
    </S.GridWrapper>
  );
};

export default GridContainer;